const DEFAULT_NATIVE_BACKEND_URL = "https://hhboekje-production.up.railway.app";
const PRODUCTION_WEB_BACKEND_URL = "https://hhboekje-production.up.railway.app";

const isLoopbackBackendUrl = (value) => {
  if (!value) return false;

  try {
    const url = new URL(String(value));
    return url.hostname === "localhost" || url.hostname === "127.0.0.1";
  } catch {
    return false;
  }
};

const isLocalWebHost = () => {
  if (typeof window === "undefined") return false;

  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

export const isNativePlatform = () => {
  if (typeof window === "undefined") return false;
  return window.Capacitor?.isNativePlatform?.() === true;
};

export const getBackendBaseUrl = () => {
  const explicitBackendUrl = process.env.REACT_APP_BACKEND_URL;
  if (explicitBackendUrl) {
    // Prevent shipping a native/TestFlight build that still points to a developer's localhost.
    if (!(isNativePlatform() && isLoopbackBackendUrl(explicitBackendUrl))) {
      return explicitBackendUrl.replace(/\/+$/, "");
    }
  }

  const runtimeBackendUrl = window.__HHBOEKJE_BACKEND_URL__;
  if (runtimeBackendUrl) {
    return String(runtimeBackendUrl).replace(/\/+$/, "");
  }

  if (isNativePlatform()) {
    return DEFAULT_NATIVE_BACKEND_URL;
  }

  if (isLocalWebHost()) {
    return "http://localhost:8000";
  }

  return PRODUCTION_WEB_BACKEND_URL;
};
